
import { Component, Mixins } from "vue-property-decorator";
import { default as StyledDrawableObjectMixin } from "./StyledDrawableObjectMixin.vue";
import { default as StyledTextDrawableMixin } from "./StyledTextDrawableMixin.vue";

@Component({
})
export default class StyledTextDrawableObjectMixin extends Mixins(
  StyledDrawableObjectMixin,
  StyledTextDrawableMixin
) {
}
